import { variables } from 'swag-client-common/styles/variables-js';
export const useStyles = theme => ({
  root: {},
  container: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '75px'
  },
  input: {
    color: theme.palette.secondary.main,
    fontFamily: 'inherit',
    textAlign: 'center'
  },
  inputs: {
    display: 'flex',
    color: variables.colorGrey06,
    justifyContent: 'space-between'
  },
  underline: {
    borderBottom: `1px solid ${variables.colorGreyBorder}`,
    '&:hover::before': {
      borderBottom: `1px solid ${variables.colorGrey9} !important`
    },
    '&::after': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.87);'
    },
    '&::before': {
      borderBottom: `1px solid ${variables.colorGreyBorder}`
    }
  },
  track: {
    backgroundColor: variables.colorGrey01
  },
  rail: {
    backgroundColor: variables.colorGrey15
  }
});